import React from 'react';
import { useReveal } from '@/lib/motion';

/** Smooth orange divider that draws in horizontally when in viewport. */
export default function SectionDivider() {
  const { ref, revealed } = useReveal({ threshold: 0.3 });
  return (
    <div className="w-full flex justify-center py-3" aria-hidden>
      <span
        ref={ref}
        className="block h-[1px] bg-brand-orange origin-left transition-transform duration-[400ms] ease-out"
        style={{ width: 80, transform: revealed ? 'scaleX(1)' : 'scaleX(0)' }}
      />
    </div>
  );
}
